<template>
  <v-container
    fluid
    class="px-4"
  >
    <v-expansion-panels
      v-model="panel"
      :disabled="disabled"
    >
      <v-expansion-panel>
        <v-expansion-panel-header><h3>Organization</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <Organization />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header><h3>Users</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <Users />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header><h3>Business Rules</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <BusinessRules />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header><h3>Equipment</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <Equipment />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header><h3>Inventory</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-tabs
            v-model="inventoryTab"
            class="mb-4"
          >
            <v-tab
              v-for="item in inventoryTabs"
              :key="item"
            >
              {{ item }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="inventoryTab">
            <v-tab-item>
              <Items />
            </v-tab-item>
            <v-tab-item>
              <InventorySupplierItems />
            </v-tab-item>
            <v-tab-item>
              <Colors />
            </v-tab-item>
            <v-tab-item>
              <Lengths />
            </v-tab-item>
            <v-tab-item>
              <Shelves />
            </v-tab-item>
            <v-tab-item>
              <InventoryCategories />
            </v-tab-item>
            <v-tab-item>
              <PhysicalCountList />
            </v-tab-item>
            <v-tab-item>
              <DangerLevels />
            </v-tab-item>
            <v-tab-item>
              <InventoryPo />
            </v-tab-item>
            <v-tab-item>
              <InventoryParameters />
            </v-tab-item>
          </v-tabs-items>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header><h3>Glass</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-tabs
            v-model="glassTab"
            class="mb-4"
          >
            <v-tab
              v-for="item in glassTabs"
              :key="item"
            >
              {{ item }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="glassTab">
            <v-tab-item>
              <Glass />
            </v-tab-item>
            <v-tab-item>
              <GlassSpecification />
            </v-tab-item>
            <v-tab-item>
              <GlassPaintCodes />
            </v-tab-item>
          </v-tabs-items>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header><h3>RM Supply / Scrap Reasons</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <SupplyToLine />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header><h3>Data Sync</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <DataSync />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header><h3>Reports</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <Reports />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header><h3>Webhooks</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <Webhooks />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header><h3>Truck Schedule / Bill Of Lading</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-tabs
            v-model="truckScheduleTab"
            class="mb-4"
          >
            <v-tab
              v-for="item in truckScheduleTabs"
              :key="item"
            >
              {{ item }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="truckScheduleTab">
            <v-tab-item>
              <TruckSchedule />
            </v-tab-item>
            <v-tab-item>
              <BillOfLading />
            </v-tab-item>
          </v-tabs-items>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header><h3>Dashboards</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <Dashboards />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header><h3>Time Off</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <TimeOff />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header><h3>Windows</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-tabs
            v-model="windowTab"
            class="mb-4"
          >
            <v-tab
              v-for="item in windowTabs"
              :key="item"
            >
              {{ item }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="windowTab">
            <v-tab-item>
              <Windows />
            </v-tab-item>
            <v-tab-item>
              <AluminumDie />
            </v-tab-item>
            <v-tab-item>
              <CommercialType />
            </v-tab-item>
          </v-tabs-items>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header><h3>Panels</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <Panel />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header><h3>VMS</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <Vms />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header><h3>Email Notifications</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <Notification />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header><h3>WIP (Components)</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-tabs
            v-model="WipTab"
            class="mb-4"
          >
            <v-tab
              v-for="item in WipTabs"
              :key="item"
            >
              {{ item }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="WipTab">
            <v-tab-item>
              <WipPanel />
            </v-tab-item>
          </v-tabs-items>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header><h3>Profiles</h3></v-expansion-panel-header>
        <v-expansion-panel-content>
          <Profile />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import Items from './Items';
import DangerLevels from './DangerLevels';
import Equipment from './Equipment';
import Users from './Users';
import Organization from './Organization';
import Colors from './Colors.vue';
import InventoryCategories from './InventoryCategories.vue';
import DataSync from './DataSync.vue';
// import BusinessRules from './BusinessRules_old.vue';
import PhysicalCountList from './PhysicalCountList';
import Reports from './Reports';
import Shelves from './Shelves';
import SupplyToLine from './SupplyToLine';
import Glass from './Glass';
import Webhooks from './Webhooks';
import TruckSchedule from './TruckSchedule';
import Dashboards from './Dashboards';
import Lengths from './Lengths';
import GlassSpecification from './GlassSpecification';
import GlassPaintCodes from './GlassPaintCodes';
import InventoryPo from './InventoryPo';
import TimeOff from './TimeOff';
import InventoryParameters from './InventoryParameters.vue';
import Windows from './Windows.vue';
import BillOfLading from './BillOfLading.vue';
import Panel from './Panel.vue';
import Vms from './Vms.vue';
import BusinessRules from './BusinessRules.vue';
import Notification from './Notification.vue';
import WipPanel from './WipPanel';
import InventorySupplierItems from './InventorySupplierItems.vue';
import AluminumDie from './AluminumDie.vue';
import CommercialType from './CommercialType.vue';
import Profile from './Profile.vue';

export default {
  name: 'Index',
  components: {
    Users,
    DangerLevels,
    Equipment,
    Items,
    Organization,
    Colors,
    InventoryCategories,
    DataSync,
    BusinessRules,
    PhysicalCountList,
    Reports,
    Shelves,
    SupplyToLine,
    Glass,
    Webhooks,
    TruckSchedule,
    Dashboards,
    Lengths,
    GlassSpecification,
    GlassPaintCodes,
    InventoryPo,
    TimeOff,
    InventoryParameters,
    Windows,
    BillOfLading,
    Panel,
    Vms,
    Notification,
    WipPanel,
    InventorySupplierItems,
    AluminumDie,
    CommercialType,
    Profile,
  },
  filters: {},
  data: () => ({
    selectedTab: 0,
    panel: null,
    disabled: null,
    inventoryTab: null,
    inventoryTabs: ['Raw Materials (Items)', 'Inventory Supplier Items', 'Material Colours', 'Lengths', 'Shelves', 'Material Categories', 'Physical Counts', 'Limit, Caution, Danger Levels', 'Inventory Po', 'Panels'],
    glassTab: null,
    glassTabs: ['Glass', 'Specifications', 'Paint Codes'],
    truckScheduleTab: null,
    truckScheduleTabs: ['Truck Schedule', 'Bill Of Lading'],
    WipTab: null,
    WipTabs: ['Panel'],
    windowTab: null,
    windowTabs: ['Windows', 'Aluminum Dies', 'Curtainwall Types'],
  }),
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      // const selectedTab = this.$store.getters.selectedAdmiii;
      // if (selectedTab) {
      //   this.selectedTab = selectedTab;
      // }
    },
    changeTab() {
      // Keep current tab in local storage
      // this.$store.commit('storeInventoryTab', this.selectedTab);
    },
  },
};
</script>
<style scoped>
</style>
